/* GET CHANGE HISTORY */
export const GET_ADMIN_CHANGE_HISTORY = "GET_ADMIN_CHANGE_HISTORY"
export const GET_ADMIN_CHANGE_HISTORY_SUCCESS = "GET_ADMIN_CHANGE_HISTORY_SUCCESS"
export const GET_ADMIN_CHANGE_HISTORY_ERROR = "GET_ADMIN_CHANGE_HISTORY_ERROR"
export const GET_ADMIN_CHANGE_HISTORY_EXPORT = "GET_ADMIN_CHANGE_HISTORY_EXPORT"
export const GET_ADMIN_CHANGE_HISTORY_EXPORT_SUCCESS = "GET_ADMIN_CHANGE_HISTORY_EXPORT_SUCCESS"
export const GET_ADMIN_CHANGE_HISTORY_EXPORT_ERROR = "GET_ADMIN_CHANGE_HISTORY_EXPORT_ERROR"
